
































import Vue from 'vue';

export default Vue.extend({
  name: 'Modal',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    confirm: String,
  },
  methods: {
    onModalShown() {
      (document.querySelector('body') as HTMLElement).classList.add('overflow-hidden');
    },
  },
});
